/**
 * Created by bear on 17/08/03.
 * SDK封装的业务代码层（精简版，仅保留项目使用的 statpid）
 */
import Statpid from './statpid/Statpid'

const operation = {
  statpid: new Statpid()
}

export default operation
